"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CombinedLoggers_transactionId, _CombinedLoggers_logger, _CombinedLoggers_splunkLogger;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCombinedLoggers = exports.CombinedLoggers = void 0;
const crypto_1 = require("crypto");
const logger_1 = require("./logger");
const timingEvent_1 = require("./timingEvent");
const ridUtils_1 = require("./ridUtils");
const event_1 = require("./event");
/**
 * Combined regular (info, warn, error, etc.) and splunk logger (startStage, endStage, etc.).<br>
 * To create this it's recommended to use {@link createCombinedLoggers} function.
 */
class CombinedLoggers {
    constructor(transactionId, logger, splunkLogger) {
        _CombinedLoggers_transactionId.set(this, void 0);
        _CombinedLoggers_logger.set(this, void 0);
        _CombinedLoggers_splunkLogger.set(this, void 0);
        __classPrivateFieldSet(this, _CombinedLoggers_transactionId, transactionId, "f");
        __classPrivateFieldSet(this, _CombinedLoggers_logger, logger, "f");
        __classPrivateFieldSet(this, _CombinedLoggers_splunkLogger, splunkLogger, "f");
    }
    get transactionId() {
        return __classPrivateFieldGet(this, _CombinedLoggers_transactionId, "f");
    }
    set transactionId(transactionId) {
        throw new Error("You cannot change the transaction ID after creation. Create a new CombinedLoggers instead");
    }
    get logger() {
        return __classPrivateFieldGet(this, _CombinedLoggers_logger, "f");
    }
    set logger(logger) {
        throw new Error("You cannot change the logger after creation. Create a new CombinedLoggers instead");
    }
    get splunkLogger() {
        return __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f");
    }
    set splunkLogger(splunkLogger) {
        throw new Error("You cannot change the splunkLogger after creation. Create a new CombinedLoggers instead");
    }
    //region LoggerInterface
    // Convenience access methods to the regular logger
    debug(...messages) {
        __classPrivateFieldGet(this, _CombinedLoggers_logger, "f").debug(messages);
    }
    info(...messages) {
        __classPrivateFieldGet(this, _CombinedLoggers_logger, "f").info(...messages);
    }
    warn(...messages) {
        __classPrivateFieldGet(this, _CombinedLoggers_logger, "f").warn(...messages);
    }
    error(...messages) {
        __classPrivateFieldGet(this, _CombinedLoggers_logger, "f").error(...messages);
    }
    setTransactionId() {
        throw new Error("You cannot change the transaction ID after creation. Create a new CombinedLoggers instead");
    }
    setLoggingFunction() {
        throw new Error("You cannot change the logging function after creation. Create a new CombinedLoggers instead");
    }
    //endregion LoggerInterface
    //region TimingEventInterface
    // Convenience access methods to the splunk logger
    startStage(stageName, stageMetadata, stageDestination) {
        return __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f").startStage(stageName, stageMetadata, stageDestination);
    }
    [(_CombinedLoggers_transactionId = new WeakMap(), _CombinedLoggers_logger = new WeakMap(), _CombinedLoggers_splunkLogger = new WeakMap(), timingEvent_1.addStage)](stageName, stage, metadataDestination) {
        return __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f")[timingEvent_1.addStage](stageName, stage, metadataDestination);
    }
    endStage(stageName, stageMetadata, stageDestination) {
        __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f").endStage(stageName, stageMetadata, stageDestination);
    }
    metadata(metadata, destination) {
        __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f").metadata(metadata, destination);
    }
    end(status, metadata) {
        return __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f").end(status, metadata);
    }
    complete(metadata) {
        return __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f").complete(metadata);
    }
    completeWithError(metadata) {
        return __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f").completeWithError(metadata);
    }
    endWithResponse(response) {
        return __classPrivateFieldGet(this, _CombinedLoggers_splunkLogger, "f").endWithResponse(response);
    }
}
exports.CombinedLoggers = CombinedLoggers;
/**
 * Create combined regular and splunk loggers for a transaction. Also logs the splunk "start" event message).
 * <br>
 * Sample usage:
 * <pre>
 *      // Create loggers. Use rid from myEvent as the transactionId, or let createLoggers generate one if it's missing
 *      const loggers = utils.createLoggers("module", myEvent);
 *      try {
 *          loggers.logger.info("Running stuff");
 *          ...
 *          loggers.logger.info("Running other stuff");
 *          ...
 *          loggers.logger.info("Done");
 *          loggers.splunkLogger.complete({ success: true });
 *      }
 *      catch (e) {
 *          loggers.logger.info(`Error: ${e}`);
 *          loggers.splunkLogger.error({ success: false, error: e });
 *      }
 * </pre>
 * @param flow name of flow/module/action (e.g. "narration-service-play", "detailed-reports-gateway", "dragon-generate-video")
 * @param event event to be used when creating the splunk logger (see {@link LogEvents.start})
 * @param transactionId (optional) - transaction ID for this transaction.
 *          <ol>
 *              <li>
 *                  If you supply a transaction ID, it will be used for the regular logger. It will also be
 *                  used as the default rid for the event in the splunk logger (but only if the event doesn't already have an rid).
 *              </li>
 *              <li>
 *                  If you don't supply one, and the event (see above) has a request id, the event's request id will be used as the transaction ID
 *              </li>
 *              <li>
 *                  If you don't supply one and the event has no rid, a new ID will be generated and used as <b>BOTH</b> the regular logger's
 *                      transaction ID and the event's rid (which is what you'll see in splunk message).
 *              </li>
 * @param metadata metadata to be used when creating the splunk logger (see {@link LogEvents.start})
 * @returns combined regular and splunk logger.
 */
function createCombinedLoggers(flow, event, transactionId, metadata) {
    // Between versions 5 and 6 of this we changed the order of event and transactionId.
    // To ensure no one is mistakenly sending the transactionId value as the event argument, we verify it here.
    if (event && typeof event === "string") {
        throw new Error("You called createCombinedLoggers with a string (" + event + ") as the second argument, which is the event. " +
            "This is not allowed! " +
            "Did you perhaps send the transaction ID (which is supposed to be the third argument?");
    }
    // See if the event has a request ID
    const eventRid = (0, ridUtils_1.getExistingRid)(event);
    // Use transaction ID (explicit value passed, or event rid, or generate one)
    const actualTransactionId = transactionId || eventRid || (0, crypto_1.randomUUID)();
    // If the event has no rid yet, use the transaction ID as its rid.
    if (!eventRid) {
        event = event || {};
        event.transactionId = actualTransactionId;
    }
    // Create logger and splunk logger and return them.
    const log = (0, logger_1.logger)(flow).setTransactionId(actualTransactionId);
    const splunkLogger = event_1.events.startRequest(flow, event, metadata, undefined);
    return new CombinedLoggers(actualTransactionId, log, splunkLogger);
}
exports.createCombinedLoggers = createCombinedLoggers;
//# sourceMappingURL=utils.js.map